window.addEventListener('DOMContentLoaded', function() {
    ( function( $ ) {

        $('.input__field').change(function () {
            var $this = $(this);
            var $thisInput = $this.find('input');
            if ($this.val() !== "") {
                $this.addClass('input--filled');
            } else {
                $this.removeClass('input--filled');
            }
        });

        // We need to move the 'label' that CF7 generates into the main span wrapper so that the 'hoshi' styling works!
        var spans = document.getElementsByClassName("wpcf7-form-control-wrap");

        for( var i=0 ; i < spans.length ; i++ ) {

            var input = spans[i].nextSibling;

            if( input != null ){

                if( input.tagName == "LABEL" ){

                    spans[i].appendChild( input );

                }

            }

        }

    } )( jQuery );
});

function initialize() {

    var pointA = new google.maps.LatLng(51.504573, -0.086054),
                    pointB = new google.maps.LatLng(51.502582, -0.085397),
                    imagePath = '/wp-content/themes/velo/img/gpin.png',

    mapOptions = {
            zoom: 16,
            center: pointB,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            mapTypeControl: false
    },

    map = new google.maps.Map(document.getElementById('map'), mapOptions),

    contentString = "60 Weston Streeet",
    infowindow = new google.maps.InfoWindow({
        content: contentString,
        maxWidth: 500
    }),
            
    // Instantiate a directions service.
    directionsService = new google.maps.DirectionsService,
    directionsDisplay = new google.maps.DirectionsRenderer({
        map: map,
        suppressMarkers: true
    }),

    markerB = new google.maps.Marker({
        position: pointB,
        map: map,
        icon: imagePath,
        title: 'Velo Marketing'
    });

    // get route from A to B
    calculateAndDisplayRoute(directionsService, directionsDisplay, pointA, pointB);				
				
    google.maps.event.addListener(markerB, 'click', function () {
        infowindow.open(map, markerB);
    });

    //Resize Function
    google.maps.event.addDomListener(window, "resize", function () {
        var center = map.getCenter();
        google.maps.event.trigger(map, "resize");
        map.setCenter(center);
    });
    
}

function calculateAndDisplayRoute(directionsService, directionsDisplay, pointA, pointB) {
    
    directionsService.route({
        origin: pointA,
        destination: pointB,
        travelMode: google.maps.TravelMode.TRANSIT
    }, function (response, status) {
        if (status == google.maps.DirectionsStatus.OK) {
                directionsDisplay.setDirections(response);
        } else {
                window.alert('Directions request failed due to ' + status);
        }
    });
    
}

google.maps.event.addDomListener(window, 'load', initialize);

// Add listener for the Contact Form 7 plugin that check if the form has been submitted, if so hide it completely.
document.addEventListener('wpcf7mailsent', function( event ) {
    document.getElementById('asaphide').style.display = 'none';
}, false );